// Libraries
var React = require('react');
var $ = require('jquery');

// Assets
var spinner = require('../../../common/images/Rolling.svg');

// Styles
require('./LiveResults.scss');

// Components
var LiveLeagueTable = require('./LiveLeagueTable/LiveLeagueTableModule');
var LiveScores = require('./LiveScores/LiveScoresModule');

class LiveResults extends React.Component {

	constructor(props) {
		super(props);

		this.Realtime = null;

		this.state = {
			tables: [],
			results: [],
			isLoading: true,
			updated: ""
		}
	}

	componentDidMount() {
		// delay the load of the realtime library until it's reached the browser 
		// to avoid server side rendering errors
		this.Realtime = require('../../../common/Realtime/Realtime');

		this.loadData();
		this.attachChannels();
	}

	loadData = () => {
		$.ajax({
			method: "GET",
			url: this.props.data.endpoints.find(x => x.name === "leagueTable").url
		})
			.done(data => {
				this.populateData(data);
			})
			.fail(data => {
				this.setState({ isLoading: false });
			});
	}

	populateData = (data) => {
		if (data.LeagueTable.Tables && data.LeagueTable.Tables.length > 0) {
			this.setState({ tables: data.LeagueTable.Tables, timestamp: data.LeagueTable.LeagueTableTimestamp });
		}

		if(data.Results && data.Results.length > 0) {
			this.setState({ results: data.Results });
		}

		this.setState({ isLoading: false });
	}

	attachChannels() {
		let channel = this.props.data.endpoints.find(x => x.name === "leagueTable").channelId;

		this.Realtime.subscribe(channel, this.props.data.realtimeKey, (message) => {
			this.populateData(message.data);
		});
	}

	render() {
		return (
			<div className="LiveResults">
				{this.state.isLoading &&
						<img src={spinner} className="spinner" alt="Loading animation" />
				}
				{!this.state.isLoading && this.state.results.length === 0 && this.state.tables.length === 0 &&
						<p>No live results are available</p>
				}
				{this.state.results.length > 0 &&
						<LiveScores results={this.state.results} />
				}
				{!this.state.isLoading && this.state.tables.length > 0 &&
						<h2 className="LiveResults__header">League Table</h2>
				}
				{this.state.tables.length > 0 && this.state.tables.map((table, index) => {
					return(
						<LiveLeagueTable key={index} table={table} siteTeamOptaId={this.props.data.siteTeamOptaId} baseUrl={this.props.data.baseUrl} updated={this.state.tables.LeagueTableTimestamp} />
					)
				})}
				{this.state.tables && this.state.timestamp &&
						<p>As of: {this.state.timestamp}</p>
				}
			</div>
		)
	}
}

module.exports = LiveResults;



// WEBPACK FOOTER //
// ./src/components/MDC/LiveResults/LiveResultsModule.js